import { atlas } from '~/services/serviceInstances';

import { GuidelineWithId } from '../../types/playbooks/guidelines';

export const getGuideline = async (
  guidelineId: string,
): Promise<{ data: { attributes: GuidelineWithId } }> => {
  return atlas.get(`guidelines/${guidelineId}`);
};
